import React from "react";

// Actions
import WorkflowActions from "../../../../actions/WorkflowActions";
import UIActions from "../../../../actions/UIActions";

// Scaffolding
import Card from "../../Card.react";
import Container from "../../Container.react";
import Overlay from "../../Overlay.react";

// Form items
import Input from "../../forms/Input.react";
import Button from "../../buttons/Button.react";

// Headers
import H1 from "../../headers/H1.react";
import H3 from "../../headers/H3.react";

// Functions
import validate from "../../../../functions/validate";

// Sets validation
const conceptValidation = [
	{
		type: "min-length",
		value: 4
	}
];

class NewQuestionCard extends React.Component {
	constructor(props) {
		super(props);
		this._updateFn = this._updateFn.bind(this);
		this._onClick = this._onClick.bind(this);

		this.state = { concept: "", description: "", validate: false };
	}

	componentDidMount() {
		document.getElementById("concept").focus();
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ loading: nextProps.status.indexOf("creating card") > -1 });
	}

	_onClick() {
		var conceptError = validate(conceptValidation, this.state.concept);

		if (conceptError === "") {
			this.setState({ validate: false });
			var obj = this.props.data;
			obj.concept = this.state.concept;

			WorkflowActions.addCard(obj);
			UIActions.showOverlay("", null);
		} else this.setState({ validate: true });
	}

	_onClose() {
		UIActions.showOverlay("");
	}

	_updateFn(field, location, value) {
		this.setState({ [field]: value, validate: false });
	}

	render() {
		const cardStyle = {
			width: "calc(100% - 48px)",
			padding: "24px",
			textAlign: "center"
		};

		const rowStyle = {
			width: "100%",
			textAlign: "right",
			margin: "16px 0px 0px 0px"
		};

		const buttonStyle = {
			marginLeft: "8px"
		};

		return (
			<Overlay>
				<Container maxWidth="600px" key="new-workflow-container">
					<Card style={cardStyle}>
						<H1 text="Add new card" textAlign="center" />
						<H3
							text="What information does this card capture?"
							textAlign="left"
							fontSize="20px"
							lineHeight="26px"
							margin="16px"
							width="calc(100% - 32px)"
						/>
						<Input
							id="concept"
							label="Central information"
							field="concept"
							updateFn={this._updateFn}
							validate={this.state.validate}
							validation={conceptValidation}
							onReturn={this._onClick}
							errors={this.props.errors}
							helpText="E.g., order number, email, address"
						/>
						<div style={rowStyle}>
							<Button text="Nevermind" onClick={this._onClose} type="flat" />
							<Button text="NEXT" style={buttonStyle} onClick={this._onClick} loading={this.state.loading} />
						</div>
					</Card>
				</Container>
			</Overlay>
		);
	}
}

export default NewQuestionCard;
